import {useTranslation} from "../i18n";

const DEFAULT_OPTIONS = [25, 50, 100];

// Один селектор размера страницы на все списки. Раньше он жил двумя копиями
// в SplitBillsPage и RefundsPage, и Аудит остался вовсе без пагинации (ENG-114).
export const PageSizeSelect = ({
    value,
    onChange,
    options = DEFAULT_OPTIONS,
    disabled = false,
    "aria-label": ariaLabel,
}) => {
    const {t} = useTranslation();
    const label = ariaLabel ?? t("common.pageSize.label");

    return (
        <label className="admin-field">
            <span>{label}</span>
            <select
                aria-label={label}
                value={String(value)}
                disabled={disabled}
                onChange={(event) => onChange(Number(event.target.value))}
            >
                {options.map((option) => (
                    <option key={option} value={String(option)}>
                        {option}
                    </option>
                ))}
            </select>
        </label>
    );
};
